export type IDexeroUiInteractionsBindings = IDCA.IGenericFunc;

export function _dexeroUiInteractionsBindings() {
  $(window).on('scroll', (e) => {
    window.DexeroCoreApp._toggleScrollToTopButton($(e.currentTarget));
  });

  $('body')
    .on('click', '#scroll-to-top', () => {
      ($('body') as any).scrollTo();
    })
    .on('click', '[type="submit"].disabled:not(.do-not-animate)', (e) => {
      e.preventDefault();
      return false;
    })
    .on('click', '.append-return-url', (e) => {
      e.preventDefault();
      window.DexeroCoreApp.appendCurrentUrlBeforeRedirect(
        $(e.currentTarget) as JQuery<HTMLAnchorElement>
      );
    })
    .on('click', '.language-switcher .btn', (e) => {
      window.DexeroCoreApp.switchLanguage($(e.currentTarget), 'button');
    })
    .on('change', '.language-switcher select[name="formLocaleCode"]', (e) => {
      window.DexeroCoreApp.switchLanguage($(e.currentTarget), 'select');
    })
    .on('click', '.view-readonly-child', (e) => {
      e.preventDefault();
      window.DexeroCoreApp.viewReadonlyChild($(e.currentTarget));
    })
    .on('click', '.print-target-area', window.DexeroCoreApp.printArea)
    .on('click', '.change-url-param', (e) => {
      window.DexeroCoreApp.changeUrlParamOnClick(e);
    });
}
